/* eslint-disable no-debugger */
import { useState } from 'react';
import useForm from '@usas/ui-web/utils/UseForm';
import validate from "./ClubTimesWithParamsValidate";

// Define the columns configuration for this report
const columns = [
  { width: "150px", id: "FullName", field: "fullName", title: "Full Name" },
  { width: "120px", id: "SwimDate", field: "swimDate", title: "Swim Date", format: "{0:dd/MM/yyyy}" },
  { width: "100px", id: "AgeGroupDesc", field: "ageGroupDesc", title: "Age Group" },
  { width: "100px", id: "EventCode", field: "eventCode", title: "Event Code" },
  { width: "100px", id: "CourseCode", field: "courseCode", title: "Course" },
  { width: "100px", id: "EventGender", field: "gender", title: "Event Gender" },
  { width: "200px", id: "MeetName", field: "meetName", title: "Meet Name" },
  { width: "120px", id: "SessionName", field: "sessionName", title: "Session Name" },
  { width: "120px", id: "PowerPoints", field: "powerPoints", title: "Power Points" },
  { width: "120px", id: "TimeStandardType", field: "timeStandardType", title: "Time Standard Type" },
  { width: "120px", id: "ClubCode", field: "clubCode", title: "Club Code" },
  { width: "120px", id: "LscCode", field: "lscCode", title: "LSC Code" },
  { width: "120px", id: "SwimTime", field: "swimTime", title: "Swim Time" },
  { width: "120px", id: "Rank", field: "rank", title: "Rank" }
];

const useClubTimesWithParams = () => {
  const [modalState, setModalState] = useState(getInitialModalState());

  const { formState, errorState, handleSubmit, updateFormState, onFormValueChanged } = useForm(getInitialFormState(), submitFormCallback, validate);

  function submitFormCallback() {
    setModalState({ ...modalState, displayPopUp: true });
  }

  const onRunReportClicked = (e) => {
    handleSubmit(e);
  }

  const onModalCancelClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    //setIsDirty(true);
    setModalState({ ...modalState, displayPopUp: false });
  };

  function getInitialModalState() {
    return {
      displayPopUp: false,
      currentPrimaryInfo: '',
      modalTitle: 'Report Viewer'
    };
  }

  function getInitialFormState() {
    return {
      startDate: "01/01/2025",
      endDate: "07/01/2025",
      events: [],
      competitionGenderTypeId: 1,
      courseCode: "SCY",
      ageGroupKey: 3,
      timeStandardType: "AA",
      topCount: 20
    };
  }

  return {
    formState,
    errorState,
    reportParameters: {
      startDate: formState.startDate,
      endDate: formState.endDate,
      events: formState.events.map(event => event.id).join(','),
      competitionGenderTypeId: formState.competitionGenderTypeId,
      courseCode: formState.courseCode,
      ageGroupKey: formState.ageGroupKey,
      timeStandardType: formState.timeStandardType,
      topCount: formState.topCount
    },
    parameters: formState,
    columns: columns,
    modalState,
    onModalCancelClicked,
    handleSubmit,
    onFormValueChanged,
    updateFormState,
    onRunReportClicked
  };
};

export default useClubTimesWithParams;